<template>
  <article ref="scrollBox" :class="['home']">
    <!-- <index-header :titleText='titleText'> -->
      <!-- :logoImg="logoImg" -->
    <!-- <index-header
    :titleText="titleText"
    ></index-header> -->
    <!-- <page-header></page-header> -->
    <swiper
    :swiperImgArray="indexSwiperImg"
    :swiperWrapClass="swiperClass">
    </swiper>
    
    
    
    <primary-nav
    :primaryNavArr="primaryNav" @changedScopeId="changedScopeId($event)">
    </primary-nav>
    <!-- :autoPlay = "autoplay" -->
    <!-- <nav-list></nav-list> -->
    <index-productlist 
    :secondNav="secondNav" 
    :itemList="itemList" 
    :secondNavItem="secondNavItem" 
    @changedScopeClassify="changedScopeClassify($event)"
    ></index-productlist>
    <!-- <index-footer
    :bottomNav = "bottomNav"
    ></index-footer> -->
  </article>
</template>

<script>
  // import Swiper from 'swiper'
  // import 'swiper/dist/css/swiper.css'

  import store from '@/vuex/store.js'
  
  import Header from './child-components/Header'
  import Swiper from './child-components/Swiper'
  import PrimaryNav from './child-components/PrimaryNav'
  import ProductListTmp from './child-components/ProductListTmp'
  // import ProductList from './child-components/ProductList'
  import navList from './child-components/NavList'
  import Footer from './child-components/Footer'
  // import childPageTitle from './child-components/childPageTitle'

  export default {
    name: 'home',
    // store,
    props: {

    },
    data() {
      return {
        //dom
        // scrollBox:{},
        indexSwiperImg: [{
            id: 1,
            src: "static/img/6.jpg",
            to: "/news-page"
          },
          {
            id: 2,
            src: "static/img/2.jpg",
            to: ""
          },
          {
            id: 3,
            src: "static/img/3.jpg",
            to: ""
          },
          {
            id: 4,
            src: "static/img/4.jpg",
            to: ""
          }
        ],
        swiperClass: "big_banner_wrap",
        autoplay: true,
        logoImg: true,
        titleText: "XXXXXXXXXXX商城",

        // bottomNav------------------
        bottomNav:{
          botNavShow:true,
          navItem:[
            {id:1,textContent:'首页'},
            {id:2,textContent:'我的订单'},
            {id:3,textContent:'个人中心'}
          ],
        },

        // get-----
        scopeId: null,
        scopeClassify: null,
        businessid: 0,
        primaryNav: [],
        secondNav: [],
        itemList: [],
        secondNavItem: {},
      }
    },

    components: {
      "index-header": Header,
      "swiper": Swiper,
      "primary-nav": PrimaryNav,
      // "index-productlist":ProductList,
      "index-productlist": ProductListTmp,
      "nav-list": navList,
      "index-footer": Footer,
    },
    created() {
      this.getPrimaryNav();
    },
    methods: {
      //监听页面scroll
      // monitorHomeScroll(){
      //   this.scrollBox = this.$refs.scrollBox;
      //   this.scrollBox.addEventListener('scroll',()=>{
      //     console.log(this.scrollBox.scrollTop);
      //   })
      // },

      changeVX(){
        store.commit('addCount');
      },
      goTest(){
        this.$router.push({
          path:'test-page',
        })
      },

      //选择选择二级导航
      selectSecondNav(scopeid) {  //形参为业务大类的ID
        // var index = null;
        for (let i = 0; i < this.primaryNav.length; i++) {  //遍历主导航数组,即所有业务大类
          if (this.primaryNav[i].ID == scopeid) {   //找到和传入的形参相匹配的主导航数组中的第i个
            // index = i;
            this.secondNav = this.primaryNav[i].ScopeType_Classifys;  //把主导航数组中第i个项目下的业务分类数组存下
            // console.log(this.secondNav);
            if (this.secondNav && this.secondNav.length > 0) { //如果业务分类数组-即二级导航项目有值
              this.getGoodsList(this.secondNav[0]); //执行获取商品列表方法,传入二级导航数组[下标为0,即默认首个商品分类]
            }
          }
        }
      },

      changedScopeId(scopeId) { //接收primaryNav组件发生点击一级导航事件时点击的第n个项目下的业务ID
        this.scopeId = scopeId;
        this.selectSecondNav(this.scopeId);
      },

      // changedScopeClassify(scopeClassify){
      //   this.scopeClassify = scopeClassify;
      //   this.getGoodsList(this.secondNav[scopeClassify]);
      // },

      changedScopeClassify(scopeClassify) {
        this.scopeClassify = scopeClassify;
        var index = -1;
        for (var i = 0; i < this.secondNav.length; i++) {
          if (this.secondNav[i].ID == this.scopeClassify) {
            index = i;
            break;
          }
        }
        this.getGoodsList(this.secondNav[index]);
      },


      getGoodsList(secondNavItem) {
        // var that = this;
        // this.scopeid = 0;   //业务总分类ID
        this.secondNavItem = secondNavItem; //业务类型子分类赋值到data:businessSubItem
        // console.log(this.secondNavItem);
        // this.changeIsActive(secondNavItem);

        this.$http.get("https://www.callmefix.net/api/ScopeGoods/getScopeInfoGoodsList", {
          params: {
            infoid: secondNavItem.ID, //填入参数 信息ID  传入什么拿什么........
          }
        }).then((res) => {
          this.itemList = res.body.data;
          // console.log(this.itemList);
        })
      },

      getPrimaryNav() {
        this.$http.get("https://www.callmefix.net/api/scopegoods/getScopeTypeAll", {
          params: {
            businessid: 1,
          }
        }).then((data) => {
          if (data.body.success && data.body.totalCount > 0) {
            var res = data.body;
            this.primaryNav = res.data; //存下主导航数组
            // console.log(this.primaryNav);
            this.scopeId = this.primaryNav[0].ID;  //存下主导航arr下首个项目的ID
            this.selectSecondNav(this.scopeId);  //运行选择二级导航方法,传入首个项目的ID
            // console.log(this.scopeId);
          }
        })
      },
    },
    mounted() {

    }


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import '.././style/variable';
  .home {
    // height: auto;
    .flex_wrap(initial, initial, nowrap, column);
    .overfA();
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue